/** @format */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import GridContainer from '../../../components/Grid/GridContainer';
import SearchBar from 'material-ui-search-bar';

import I18n from '../../../components/Translate/I18n';
import I18nSimple from '../../../core/i18n';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { iccidActions, iccidConstants } from '../../../modules/iccid/actions';
import TouchButton from '../../../components/Buttons/TouchButton';
import Pager from '../../../components/Adescom/Pager';
import { store } from '../../../core/store';
import { iccidReducers } from '../../../modules/iccid/reducers';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';

class IccidChooseNumberList extends Component {
    constructor(props) {
        super(props);

        store.injectReducer('iccidReducers', iccidReducers);

        this.elementPerPage = 10;

        const filter = [
            { name: 'itemsPerPage', value: this.elementPerPage },
            { name: 'iccidState', value: 0 },
        ];
        if (this.props.platformResellerId) {
            filter.push({ name: 'ownerPlatformResellerId', value: this.props.platformResellerId });
        }

        if (this.props.businessId) {
            filter.push({ name: 'businessId', value: this.props.businessId });
        }

        if (this.props.indicatedRangeId) {
            filter.push({ name: 'indicatedRangeId', value: this.props.indicatedRangeId });
        }

        if (this.props.simCard) {
            filter.push({ name: 'operatorType', value: this.props.simCard.operatorType });
        }

        this.state = {
            search: '',
            filter: filter,
            orders: [{ name: 'imsi', value: 'asc' }],
            numbersList: null,
        };
    }

    componentDidMount() {
        this.loadNumbers(this.state.filter);
    }

    loadNumbers = (searchOptions) => {
        const { dispatch } = this.props;
        const { orders } = this.state;
        const itemsLoader = new ItemLoaders(dispatch);
        itemsLoader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_iccid_pool_numbers')),
            iccidConstants.LIST_ICCID_POOL_SERIAL_CHOOSE,
            searchOptions,
            orders,
            (data) => {
                this.setState({ numbersList: data });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    onPaginationSearch = (uri) => {
        const { dispatch } = this.props;
        dispatch(
            iccidActions.getList(FormGeneralHelper.getByUri(uri), this.state.filter, this.state.orders, iccidConstants.LIST_ICCID_POOL_SERIAL_CHOOSE)
        );
    };

    searchBarOnChangeCallback = (e) => {
        this.setState({
            search: e,
        });
    };

    onCancelSearch = () => {
        if (this.state.search.length > 0) {
            this.setState(
                {
                    search: '',
                },
                this.init()
            );
        }
    };

    onRequestSearch = () => {
        const filter = this.state.filter;
        filter.push({ name: 'imsi', value: this.state.search });
        this.loadNumbers(filter);
    };

    render() {
        const { classes, clicked } = this.props;
        const { numbersList } = this.state;
        if (numbersList) {
            return (
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <Paper>
                                    <SearchBar
                                        value={this.state.search}
                                        onCancelSearch={this.onCancelSearch}
                                        onChange={this.searchBarOnChangeCallback}
                                        onRequestSearch={this.onRequestSearch}
                                        placeholder={I18nSimple.t('pools:pool.find_iccid_in_pool')}
                                        style={{
                                            margin: '0 auto',
                                        }}
                                    />
                                </Paper>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell padding="none" align="center">
                                <I18n trans="simcard:list.imsi" />
                            </TableCell>
                            <TableCell padding="none" align="center">
                                <I18n trans="simcard:list.iccid_type" />
                            </TableCell>
                            <TableCell padding="none" align="right">
                                <I18n trans="general:common.commands" />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {numbersList &&
                            numbersList['hydra:member'].map((row) => {
                                return (
                                    <TableRow key={row.id}>
                                        <TableCell padding="none" align="center">
                                            {row.imsi}
                                        </TableCell>
                                        <TableCell padding="none" align="center">
                                            {row.iccidType}
                                        </TableCell>
                                        <TableCell padding="none" align="right">
                                            <TouchButton color="info" callback={clicked} callbackParam={{ item: row }} />
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={4} className={classes.center}>
                                {numbersList && numbersList['hydra:view'] && (
                                    <Pager callback={this.onPaginationSearch} views={numbersList['hydra:view']} />
                                )}
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                </Table>
            );
        } else {
            return (
                <GridContainer justify="center">
                    <CircularProgress />
                </GridContainer>
            );
        }
    }
}

IccidChooseNumberList.propTypes = {
    classes: PropTypes.object.isRequired,
    clicked: PropTypes.func.isRequired,
    businessId: PropTypes.string,
    indicatedRangeId: PropTypes.number,
};
const mapStateToProps = (state) => {
    return {};
};
const enhance = compose(connect(mapStateToProps), withStyles(adescomStyle));
const Enhance = enhance(IccidChooseNumberList);
export default Enhance;
